const SCALE_FACTOR = 0.75

export const getScaledValue = (val: number, unit?: string): string => {
  if (unit) {
    return `${val / SCALE_FACTOR}${unit}`
  }

  return val.toString()
}
